import { createContext } from "react";
import { ActivityBlockConfigData, ActivityPosition, MessageConfigData } from "../Shared/Party/PartyConfigData";
import { EventDrivenOverlayViewEvent, MenuOverlayName, MenuOverlayView } from "./Party";
import { FanboxColorName, FanboxColorPalette } from "../Shared/Utility/Color";
import { CreateTextLayoutEngine, TextLayoutEngine } from "./TextLayoutEngine";

export type UserMessageHandler = (message: MessageConfigData) => void;



export type FeedPosition = {
    top: number;
    bottom: number;
    next: number;
}
export type MessagePositionFunction = () => FeedPosition;
export type MessagePositionFunctionNotifier = (f: MessagePositionFunction) => void;

export type VideoPosition = 'none' | 'top' | 'bottom';
export type OptionalDirection = 'top' | 'bottom';

export type UIConfig = {
    fontBase: number;
    width: number;
    height: number;
    videoHeight: number;
    videoWidth: number;
    videoPosition: VideoPosition;
    titleHeight: number;
    optionalDirection: OptionalDirection;
    optionalLimit: number;
    contolBackground: string;
    mainSpan: number[];
    videoSpan: number[];
    mainPanelHeight: number;
    showEventOverlay: (eventType: EventDrivenOverlayViewEvent, data: { [key: string]: string }) => void;
    showMenuItem : (id : MenuOverlayName) => void;
    setUserMessageHandler: (handler: UserMessageHandler) => void;
    getUserMessageHandler: () => UserMessageHandler | null;
    messagePositionNotifier: MessagePositionFunctionNotifier;
    likeChange(id: string, status: boolean): void;
    showOptional: (id: string) => void;
    fanboxColor: (name: FanboxColorName) => string;
    textLayout : TextLayoutEngine;
}

export const UpdateUIConfig = (uiConfig: UIConfig, main: ActivityBlockConfigData) => {
    if (main.mediaPosition === 'top' || main.mediaPosition === 'all') {
        uiConfig.videoPosition = 'top';
        uiConfig.optionalDirection = 'bottom';
    }
    else {
        uiConfig.videoPosition = 'bottom';
        uiConfig.optionalDirection = 'top';
    }
    const videoHeightMultiplier = uiConfig.videoPosition === 'top' ? 1.0 : 0.5;

    const postHeight = uiConfig.height - uiConfig.titleHeight - videoHeightMultiplier * uiConfig.videoHeight;

    if (uiConfig.videoPosition === 'top') {
        uiConfig.videoSpan = [0, uiConfig.videoHeight];
        uiConfig.mainSpan = [uiConfig.videoHeight, uiConfig.videoHeight + postHeight];
        uiConfig.mainPanelHeight = uiConfig.videoHeight + postHeight;
        uiConfig.optionalDirection = 'bottom';
        uiConfig.optionalLimit = uiConfig.videoHeight;
    }
    else {
        uiConfig.optionalDirection = 'top';
        uiConfig.mainSpan = [0, postHeight];
        uiConfig.videoSpan = [postHeight, uiConfig.videoHeight + postHeight];
        uiConfig.mainPanelHeight = uiConfig.videoHeight + postHeight;
        uiConfig.optionalLimit = postHeight;
    }
}

export const CreateEmptyUIConfig = (): UIConfig => {
    return {
        fontBase: 16,
        width: 0,
        height: 0,
        contolBackground: '#303030',
        showEventOverlay: (eventType: EventDrivenOverlayViewEvent, data: { [key: string]: string }) => { },
        showMenuItem : (id : MenuOverlayName) => {},
        setUserMessageHandler: (handler: UserMessageHandler) => { },
        getUserMessageHandler: () => null,
        messagePositionNotifier: (f: MessagePositionFunction) => { },
        likeChange: (id: string, status: boolean) => { },
        showOptional: (id: string) => { },
        videoHeight: 0,
        videoWidth: 0,
        videoPosition: 'none',
        titleHeight: 0,
        optionalDirection: 'bottom',
        optionalLimit: 0,
        mainSpan: [0, 0],
        videoSpan: [0, 0],
        mainPanelHeight: 0,
        fanboxColor: (name: FanboxColorName) => { const ret = FanboxColorPalette.get(name) ?? '#888888'; return ret; },
        textLayout : CreateTextLayoutEngine()

    }

}

export const UIConfigContext = createContext<UIConfig>(CreateEmptyUIConfig());